import { Grid } from "@mui/material";
import React, { useMemo } from "react";
import PropTypes from "prop-types";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import useStyles from "./useStyles";
import LinkListContainer from "./components/LinkListContainer";

const SubNavigation = React.memo(({ menuItem, mainMenuLinks, onLinkActiveChange }) => {
  const classes = useStyles();
  const links = useMemo(() => MegaMenuItemPresenter.childrenMenu(menuItem), [menuItem]);

  return (
    <Grid container className={classes.root}>
      <LinkListContainer links={links} mainMenuLinks={mainMenuLinks} onLinkActiveChange={onLinkActiveChange} />
    </Grid>
  );
});

SubNavigation.displayName = "SubNavigation";

SubNavigation.propTypes = {
  menuItem: MegaMenuItemPresenter.shape(),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onLinkActiveChange: PropTypes.func,
};

export default SubNavigation;
